import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatePipe } from './translate.pipe';

/**
 * Module that encapsulates all custom pipes for the application
 */
@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    TranslatePipe
  ],
  exports: [
    TranslatePipe  // Export for use in templates
  ]
})
export class PipesModule { } 